export default class AddressCoordinates {
    longitude: number = 0;
    latitude: number = 0;
}